"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userGuardiansController = function () {
  function userGuardiansController() {
    "ngInject";

    (0, _classCallCheck3.default)(this, userGuardiansController);
  }

  (0, _createClass3.default)(userGuardiansController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.gridOptions = {
        dataSource: this.guardians,
        sortable: true,
        pageable: false,
        resizable: true,
        noRecords: {
          template: "No Guardians."
        },
        columns: [{ field: "firstName", title: "First Name", filterable: false, width: "6rem" }, { field: "lastName", title: "Last Name", filterable: false, width: "6rem" }, { field: "relationship", title: "Relationship", filterable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getRelationship(dataItem.relationship);
          } }, { field: "status", title: "Status", filterable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getGuardianStatus(dataItem.status);
          } }, { field: "email", title: "Email", filterable: false, width: "6rem" }, { field: "phoneNumber", title: "Phone Number", filterable: false, width: "6rem" }, { field: "submissionDate", title: "Submission Date", filterable: false, width: "4rem", template: "#= submissionDate ? kendo.toString(new Date(submissionDate), 'dd-MM-yyyy') : '-' #" }, { field: "approvalDate", title: "Approval Date", filterable: false, width: "4rem", template: "#= approvalDate ? kendo.toString(new Date(approvalDate), 'dd-MM-yyyy') : '-' #" }]
      };
    }
  }, {
    key: "_getGuardianStatus",
    value: function _getGuardianStatus(status) {
      switch (status) {
        case _constants2.default.guardianStatus.PENDING:
          return "Pending";
        case _constants2.default.guardianStatus.APPROVED:
          return "Approved";
        case _constants2.default.guardianStatus.CANCELLED:
          return "Cancelled";
        case _constants2.default.guardianStatus.NONE:
          return "-";
      }
    }
  }, {
    key: "_getRelationship",
    value: function _getRelationship(relationship) {
      switch (relationship) {
        case _constants2.default.guardianRelation.FATHER:
          return "Father";
        case _constants2.default.guardianRelation.MOTHER:
          return "Mother";
        case _constants2.default.guardianRelation.LEGALGUARDIAN:
          return "Legal Guardian";
      }
    }
  }]);
  return userGuardiansController;
}();

exports.default = userGuardiansController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-guardians/user-guardians.controller.js
 **/